import React, { useMemo } from 'react';

import {
  Stack,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
} from '@gogame/components';

import { PreviewFile } from 'scenes/Gallery/components/File';

import {
  AttributeItem,
  AttributeList,
} from 'scenes/Gallery/components/AttributeList';

const useStyles = makeStyles({
  container: {
    overflowX: 'hidden',
  },
});

const SelectedPreviewGrid = ({ selectedRows, heightCover }) => {
  const classes = useStyles();

  const list = useMemo(() => {
    return [...selectedRows].reverse();
  }, [selectedRows]);

  return (
    <Stack spacing={1}>
      <Typography color={'textSecondary'}>Selected:</Typography>
      <Stack direction={'row'} spacing={1}>
        <TableContainer className={classes.container}>
          <Table>
            <TableBody>
              {list.map(({ id, name, src, videoLength, thumbnail }) => (
                <TableRow key={id}>
                  <TableCell width={134} size={'small'}>
                    <PreviewFile
                      src={src}
                      thumbnail={thumbnail}
                      width={110}
                      height={60}
                      heightCover={heightCover}
                      attributes={
                        videoLength ? (
                          <AttributeList
                            justifyContent={'space-between'}
                            direction={'row-reverse'}
                            color={'common.white'}
                            spacing={0.5}
                            p={0.5}
                          >
                            <AttributeItem
                              valueParser={'fileVideoLength'}
                              value={videoLength}
                            />
                          </AttributeList>
                        ) : null
                      }
                      withOverlay={true}
                    />
                  </TableCell>
                  <TableCell size={'small'}>{name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Stack>
  );
};

export default SelectedPreviewGrid;
